<!-- Standard notification message-->
@if (!data.errorType) {
  <div class="uk-grid uk-grid-small uk-flex-middle" uk-grid>
    <div class="uk-width-expand">{{ data.message }}</div>
    @if (data.duration === 0) {
      <div class="uk-width-auto">
        <a (click)="dismissMessage()" style="color: #ffffff; margin-left: 10px">DISMISS</a>
      </div>
    }
  </div>
}

<!-- System http error message -->
@if (data.errorType === 'system') {
  <div class="uk-grid uk-grid-collapse uk-grid-match uk-flex-middle" uk-grid>
    <div class="uk-width-expand">
      <div class="uk-grid uk-grid-collapse" uk-grid>
        <div class="uk-width-1-1"><strong>{{ data.title }}</strong></div>
        <div class="uk-width-expand">{{ data.message }}</div>
      </div>
    </div>
    @if (data.duration === 0) {
      <div class="uk-width-auto">
        <a (click)="dismissMessage()" style="color: #ffffff; margin-left: 10px">DISMISS</a>
      </div>
    }
  </div>
}

<!-- Application error message -->
@if (data.errorType === 'application') {
  <div uk-grid class="uk-grid-collapse uk-grid-match uk-width-auto">
    <div class="errorBlock uk-padding-small uk-width-auto">
      <span class="material-icons">warning_amber</span>
    </div>
    <div class="uk-width-expand uk-padding-small">
      <div class="uk-grid uk-grid-collapse">
        <h3 class="uk-width-1-1">{{ data.title }}</h3>
        <div class="uk-width-expand">
          {{ data.message }}
        </div>
        <div class="uk-width-auto">
          <a (click)="dismissMessage()" style="color: #ffffff !important; margin-left: 10px">DISMISS</a>
        </div>
      </div>
    </div>
  </div>
}
